exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-title{display:block;font-size:1.5rem;line-height:1.25;text-align:center;color:tomato;padding:0;margin:0 0 1.5rem;text-transform:uppercase;font-weight:400;position:relative}.o-title:before{border-top:1px solid tomato}.o-title:after{border-bottom:1px solid tomato}.o-title:after,.o-title:before{content:\"\";display:block;height:.7rem}@media (min-width:60em){.o-title{display:none}}", ""]);

// exports
